import initialState from './initialState';
import {
  FETCH_ACCOUNT_DRIVER_INIT,
  FETCH_ACCOUNT_DRIVER_SUCCESS,
  FETCH_ACCOUNT_DRIVER_FAILURE,
  FETCH_ACCOUNT_DRIVER_EXTENDED_PROPERTIES_INIT,
  FETCH_ACCOUNT_DRIVER_EXTENDED_PROPERTIES_SUCCESS,
  FETCH_ACCOUNT_DRIVER_EXTENDED_PROPERTIES_FAILURE,
  FETCH_ACCOUNT_DRIVER_NO_LOADING_INIT,
  FETCH_ACCOUNT_DRIVER_NO_LOADING_SUCCESS,
  FETCH_ACCOUNT_DRIVER_NO_LOADING_FAILURE,
  SAVE_ACCOUNT_DRIVER_INIT,
  SAVE_ACCOUNT_DRIVER_SUCCESS,
  SAVE_ACCOUNT_DRIVER_FAILURE,
  UPDATE_ACCOUNT_DRIVER_INIT,
  UPDATE_ACCOUNT_DRIVER_SUCCESS,
  UPDATE_ACCOUNT_DRIVER_FAILURE,
  DELETE_ACCOUNT_DRIVER_INIT,
  DELETE_ACCOUNT_DRIVER_SUCCESS,
  DELETE_ACCOUNT_DRIVER_FAILURE,
  FETCH_ACCOUNT_DRIVER_COUNT_INIT,
  FETCH_ACCOUNT_DRIVER_COUNT_SUCCESS,
  FETCH_ACCOUNT_DRIVER_COUNT_FAILURE,
  RESET_MODAL,
  RESET_ACCOUNT_DRIVER,
  FETCH_DOWNLOAD_ACCOUNT_DRIVER_SUCCESS,
  FETCH_DOWNLOAD_ACCOUNT_DRIVER_FAILURE,
  FETCH_DOWNLOAD_ACCOUNT_DRIVER_INIT,
  FETCH_UPLOAD_ACCOUNT_DRIVER_SUCCESS,
  FETCH_UPLOAD_ACCOUNT_DRIVER_FAILURE,
  FETCH_UPLOAD_ACCOUNT_DRIVER_INIT,
  RESET_MODAL_FILE,
  ACTIVE_ACCOUNT_DRIVER_INIT,
  ACTIVE_ACCOUNT_DRIVER_SUCCESS,
  ACTIVE_ACCOUNT_DRIVER_FAILURE
} from '../../actions/account_driver/types';

export default function accountDriver(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACCOUNT_DRIVER_INIT:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_ACCOUNT_DRIVER_SUCCESS:
      return {
        ...state,
        datos: action.payload.data,
        error: null,
        loading: false,
        status: action.payload.status
      };
    case FETCH_ACCOUNT_DRIVER_FAILURE:
      return {
        ...state,
        datos: [],
        error: action.payload,
        loading: false
      };
    case FETCH_ACCOUNT_DRIVER_NO_LOADING_INIT:
      return {
        ...state,
        error: null,
        loadingTable: true
      };
    case FETCH_ACCOUNT_DRIVER_NO_LOADING_SUCCESS:
      return {
        ...state,
        datos: action.concat ? state.datos.concat(action.payload.data) : action.payload.data,
        error: null,
        status: action.payload.status,
        loadingTable: false
      };
    case FETCH_ACCOUNT_DRIVER_NO_LOADING_FAILURE:
      return {
        ...state,
        loadingTable: false,
        status: 500
      };
    case FETCH_ACCOUNT_DRIVER_EXTENDED_PROPERTIES_INIT:
      return {
        ...state,
        error: null
      };
    case FETCH_ACCOUNT_DRIVER_EXTENDED_PROPERTIES_SUCCESS:
      return {
        ...state,
        extendedProperties: action.payload.data,
        error: null,
        status: action.payload.status
      };
    case FETCH_ACCOUNT_DRIVER_EXTENDED_PROPERTIES_FAILURE:
      return {
        ...state,
        extendedProperties: [],
        error: action.payload
      };
    case SAVE_ACCOUNT_DRIVER_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case SAVE_ACCOUNT_DRIVER_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case SAVE_ACCOUNT_DRIVER_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    case FETCH_ACCOUNT_DRIVER_COUNT_INIT:
      return {
        ...state,
        error: null
      };
    case FETCH_ACCOUNT_DRIVER_COUNT_SUCCESS:
      return {
        ...state,
        count: action.payload.data,
        error: null,
        status: action.payload.status
      };
    case FETCH_ACCOUNT_DRIVER_COUNT_FAILURE:
      return {
        ...state,
        count: {},
        error: action.payload
      };
    case UPDATE_ACCOUNT_DRIVER_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case UPDATE_ACCOUNT_DRIVER_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case UPDATE_ACCOUNT_DRIVER_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    case DELETE_ACCOUNT_DRIVER_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case DELETE_ACCOUNT_DRIVER_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case DELETE_ACCOUNT_DRIVER_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    case RESET_MODAL:
      return {
        ...state,
        loadingSave: false,
        statusSave: null,
        dataSave: {}
      };
    case RESET_ACCOUNT_DRIVER:
      return {
        ...state,
        datos: [],
        count: {},
        loading: true,
        error: null,
        status: null,
        loadingTable: false,
        loadingSave: false,
        statusSave: null,
        dataSave: {}
      };
    case FETCH_DOWNLOAD_ACCOUNT_DRIVER_INIT:
      return {
        ...state,
        loadingFile: true,
        error: null
      };
    case FETCH_DOWNLOAD_ACCOUNT_DRIVER_SUCCESS:
      return {
        ...state,
        datosFile: action.payload.data,
        error: null,
        loadingFile: false,
        statusFile: action.payload.status
      };
    case FETCH_DOWNLOAD_ACCOUNT_DRIVER_FAILURE:
      return {
        ...state,
        loadingFile: false,
        status: 500
      };
    case FETCH_UPLOAD_ACCOUNT_DRIVER_INIT:
      return {
        ...state,
        loadingFile: true,
        error: null
      };
    case FETCH_UPLOAD_ACCOUNT_DRIVER_SUCCESS:
      return {
        ...state,
        datosFile: action.payload.data,
        error: null,
        loadingFile: false,
        statusFile: action.payload.status
      };
    case FETCH_UPLOAD_ACCOUNT_DRIVER_FAILURE:
      return {
        ...state,
        loadingFile: false,
        status: 500
      };
    case RESET_MODAL_FILE:
      return {
        ...state,
        loadingFile: false,
        statusFile: null,
        datosFile: {}
      };
    case ACTIVE_ACCOUNT_DRIVER_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case ACTIVE_ACCOUNT_DRIVER_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case ACTIVE_ACCOUNT_DRIVER_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/account_driver/index.js